import React from "react";
import { AuthProvider } from "./AuthContext";
import { ClientsProvider } from "./ClientsContext";

const ContextWrapper: React.FC = ({ children }) => {
  return (
    <AuthProvider>
      <ClientsProvider>{children}</ClientsProvider>
    </AuthProvider>
  );
};

export default ContextWrapper;
